// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__Q9bEL","content":"RecentSearches_content__1c2Ch"};